export const AdminSettingsEndpoints = {
  root: 'settings'
}
